import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { addDays, format } from 'date-fns';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

import { useDispatch, useSelector } from 'react-redux';
import {
  CREATE_AIRPORT_TRANSFER_BOOKING_EMPTY,
  CREATE_CLIENT_USER_EMPTY,
  GET_AIRPORTS_BASED_ON_CONFIG_ID_EMPTY,
  GET_AUTOCOMPLETE_LOCATION,
  GET_AUTOCOMPLETE_LOCATION_EMPTY,
  GET_BENEFIT_ITEMS,
  GET_BENEFIT_ITEMS_EMPTY,
  GET_BINS_LIST_EMPTY,
  GET_CLIENT_BENEFIT_CONFIG_EMPTY,
  GET_CLIENT_HISTORY_LIST,
  GET_MEMBERSHIPS_DATA_EMPTY,
  GET_PAYMENT_SUMMARY_EMPTY,
  GET_RECENT_SEARCHES_EMPTY,
  UPDATE_PROFILE,
  UPDATE_PROFILE_EMPTY,
  VALIDATE_FLIGHT_DETAILS_EMPTY,
  VALIDATE_LOCATION_EMPTY,
} from '../../../../../../store/actions';
import BreadcrumbTrail from '../../../../../Common/BreadcrumbTrail';
import BookingDetails from './Components/BookingDetails';
import LocationDetailsForm from './Components/Forms/Form1-LocationDetails';
import PassengerDetailsForm from './Components/Forms/Form2-PassengerDetails';
import BookingDetailsForm from './Components/Forms/Form3-BookingDetails';
import MapSection from './Components/Map';
import PersonalDetailsPage from './Components/PersonalDetails';
import ProgressStepper from './Components/Stepper';
import UserSelection from './Components/UserSelection';
import SaveAddressModal from './Components/Modals/SaveAddress';

export default function AirportTransferBookingV2() {
  const history = useHistory();
  const dispatch = useDispatch();

  const [selectedDate, setSelectedDate] = useState(addDays(new Date(), 5));
  const [selectedTime, setSelectedTime] = useState('12:00 PM');

  const [allDates, setAllDates] = useState([]);
  const [allTimes, setAllTimes] = useState([]);

  console.log('selectedDateselectedDate', selectedDate);

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [currentActiveForm, setCurrentActiveForm] = useState(1);
  const [bookingsDetails, setBookingsDetails] = useState(null);
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [isUserExist, setIsUserExist] = useState(null);
  const [flightNumber, setFlightNumber] = useState<string>('');
  const [locationDetails, setLocationDetails] = useState(null);
  const [additionalDirectionData, setAdditionalDirectionData] = useState(null);

  const [isShowAddressModal, setIsShowAddressModal] = useState(false);
  const [isAddresSaved, setIsAddressSaved] = useState(false);

  const [passengerDetails, setPassengerDetails] = useState({
    number_of_passengers: 1,
    number_of_luggages: 0,
    number_of_baby_seats: 0,
    number_of_infants: 0,
  });

  const [randomUUID, setRandomUUID] = useState(generateRandomString());
  const [currentScreen, setCurrentScreen] = useState('USER_DETAILS');

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { createBookingRes, createBookingLoading } = useSelector((state: any) => ({
    createBookingRes: state?.CreateAirportTransferBooking?.data,
    createBookingLoading: state?.CreateAirportTransferBooking?.loading,
  }));

  const { historyData, historyDataLoading } = useSelector((state: any) => ({
    historyData: state?.GetClientHistoryList?.data,
    historyDataLoading: state?.GetClientHistoryList?.loading,
  }));

  const { updateProfile, updateProfileLoading } = useSelector((state: any) => ({
    updateProfile: state?.UpdateProfile?.data,
    updateProfileLoading: state?.UpdateProfile?.loading,
  }));

  const { benefitItemData, benefitItemDataLoading } = useSelector((state: any) => ({
    benefitItemData: state?.GetBenefitItems?.data,
    benefitItemDataLoading: state?.GetBenefitItems?.loading,
  }));

  useEffect(() => {
    if (updateProfile !== null) {
      dispatch({
        type: UPDATE_PROFILE_EMPTY,
      });
      setIsAddressSaved(true);
    }
  }, [updateProfile]);

  useEffect(() => {
    if (locationDetails !== null) {
      if (locationDetails?.service_type === `Drop`) {
        const isPlaceIdExists = isUserExist?.addresses?.some(obj => Object.values(obj).includes(locationDetails?.from?.place_id));

        if (isPlaceIdExists) {
          setIsAddressSaved(true);
        } else {
          setIsAddressSaved(false);
        }

        // locationData?.from?.place_id
      } else if (locationDetails?.service_type === `Pickup`) {
        const isPlaceIdExists = isUserExist?.addresses?.some(obj => Object.values(obj).includes(locationDetails?.to?.place_id));

        if (isPlaceIdExists) {
          setIsAddressSaved(true);
        } else {
          setIsAddressSaved(false);
        }
      }
    }
  }, [locationDetails]);

  useEffect(() => {
    if (locationDetails?.airport_id && selectedConfig?.objectId) {
      console.log('loading config data', {
        locationDetails,
        selectedConfig,
        params: {
          benefitConfigId: selectedConfig?.objectId,
          userId: isUserExist?.userId,
          airportId: locationDetails?.airport_id,
        },
      });

      dispatch({
        type: GET_BENEFIT_ITEMS,
        payload: {
          urlParam: {
            benefitConfigId: selectedConfig?.objectId,
            userId: isUserExist?.userId,
            // airportId: locationDetails?.airport_id,
          },
        },
      });
    }
  }, [locationDetails, selectedConfig]);

  useEffect(() => {
    return () => {
      setCurrentScreen(`USER_DETAILS`);
    };
  }, []);

  useEffect(() => {
    if (historyData !== null) {
      setCurrentScreen(`BOOKING_COMPLETE`);

      dispatch({
        type: CREATE_AIRPORT_TRANSFER_BOOKING_EMPTY,
      });
    }
  }, [historyData]);

  useEffect(() => {
    if (createBookingRes !== null) {
      dispatch({
        type: GET_CLIENT_HISTORY_LIST,
        payload: {
          urlParam: {
            pageIndex: 0,
            bookingTypeId: 5,
          },
          data: {
            bookingId: `${createBookingRes?.BookingId}`,
          },
        },
      });
    }
  }, [createBookingRes]);

  useEffect(() => {
    dispatch({
      type: GET_AIRPORTS_BASED_ON_CONFIG_ID_EMPTY,
    });

    dispatch({
      type: GET_AUTOCOMPLETE_LOCATION_EMPTY,
    });

    dispatch({
      type: GET_RECENT_SEARCHES_EMPTY,
    });

    dispatch({
      type: VALIDATE_LOCATION_EMPTY,
    });

    dispatch({
      type: VALIDATE_FLIGHT_DETAILS_EMPTY,
    });

    dispatch({
      type: CREATE_AIRPORT_TRANSFER_BOOKING_EMPTY,
    });

    dispatch({
      type: GET_PAYMENT_SUMMARY_EMPTY,
    });

    dispatch({
      type: CREATE_CLIENT_USER_EMPTY,
    });

    dispatch({
      type: GET_BENEFIT_ITEMS_EMPTY,
    });

    dispatch({
      type: GET_BINS_LIST_EMPTY,
    });

    dispatch({
      type: GET_CLIENT_BENEFIT_CONFIG_EMPTY,
    });

    dispatch({
      type: GET_MEMBERSHIPS_DATA_EMPTY,
    });

    setCurrentScreen(`USER_DETAILS`);

    return () => {
      window.location.reload();
    };
  }, []);

  useEffect(() => {
    if (selectedConfig) {
      dateTimeCalculation(selectedConfig);
    }
  }, [selectedConfig]);

  const onSaveAddress = locationData => {
    let payloadData = {};

    if (locationData?.service_type === `Pickup`) {
      payloadData = {
        country: locationData?.to?.address_details?.country ?? '',
        latitude: locationData?.to?.geometry?.location?.lat ?? '',
        longitude: locationData?.to?.geometry?.location?.lng ?? '',
        nickname: locationData?.nickname,
        placeId: locationData?.to?.place_id,
        postalCode: locationData?.to?.address_details?.post_code ?? '',
        streetAddress: locationData?.to?.address_details?.address ?? '',
        region: locationData?.to?.address_details?.region ?? '',
        regionId: parseInt(locationData?.to?.address_details?.regionId ?? '0'),
        subRegionId: parseInt(locationData?.to?.address_details?.subregionId ?? '0'),
        subregion: locationData?.to?.address_details?.subregion ?? '',
      };
    } else if (locationData?.service_type === `Drop`) {
      payloadData = {
        country: locationData?.from?.address_details?.country ?? '',
        latitude: locationData?.from?.geometry?.location?.lat ?? '',
        longitude: locationData?.from?.geometry?.location?.lng ?? '',
        nickname: locationData?.nickname,
        placeId: locationData?.from?.place_id,
        postalCode: locationData?.from?.address_details?.post_code ?? '',
        streetAddress: locationData?.from?.address_details?.address ?? '',
        region: locationData?.from?.address_details?.region ?? '',
        regionId: parseInt(locationData?.from?.address_details?.regionId ?? '0'),
        subRegionId: parseInt(locationData?.from?.address_details?.subregionId ?? '0'),
        subregion: locationData?.from?.address_details?.subregion ?? '',
      };
    }

    dispatch({
      type: UPDATE_PROFILE,
      payload: {
        data: {
          addresses: [
            {
              ...payloadData,
            },
          ],
        },
        urlParams: {
          userId: isUserExist?.userId,
        },
      },
    });
  };

  const dateTimeCalculation = selectedConfig => {
    let datesArray = [];
    if (selectedConfig?.tat?.delayedMinTat && selectedConfig?.tat?.delayedMaxTat) {
      datesArray = getMiddleDates(selectedConfig?.tat?.delayedMinTat, selectedConfig?.tat?.delayedMaxTat);
    }
    const allTimes = generateDailyTimeSlots();

    setAllDates(datesArray ?? []);
    setAllTimes(allTimes ?? []);
  };

  function getMiddleDates(startOffset, endOffset) {
    if (startOffset >= endOffset) {
      return [];
      // throw new Error('startOffset must be less than endOffset');
    }

    const today = new Date();
    const middleDates = [];

    for (let i = startOffset; i < endOffset; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      middleDates.push(date);
    }

    return middleDates;
  }

  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/client/dashboard`);
    }
  };

  console.log('isUserExistisUserExist', isUserExist);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadcrumbTrail title={`Airport Bookings`} navigationby={breadcrumNavigationHandler} navigation={[`Dashboard`, `Airport Bookings`]} />

        {!isAddresSaved && isShowAddressModal && (
          <SaveAddressModal
            onCloseHandler={() => {
              setIsShowAddressModal(false);
            }}
            onSaveAddress={onSaveAddress}
            locationDetails={locationDetails}
            updateProfileLoading={updateProfileLoading}
          />
        )}

        {currentScreen === `USER_DETAILS` && (
          <PersonalDetailsPage
            isUserExist={isUserExist}
            setIsUserExist={setIsUserExist}
            setSelectedConfig={setSelectedConfig}
            bookingsDetails={bookingsDetails}
            setBookingsDetails={setBookingsDetails}
            setCurrentScreen={setCurrentScreen}
          />
        )}

        {currentScreen !== `USER_DETAILS` && (
          <Card>
            {/* <CardHeader className="d-flex justify-content-end">
              <h6 className="card-title mb-0 flex-grow-1 custom-card-title"> Airport Transfer Mannual Booking </h6>
            </CardHeader> */}

            <CardBody>
              <div className="card-body-container">
                {currentScreen === `BOOKING_FLOW` && (
                  <>
                    <Row>
                      <Col>
                        <UserSelection name={isUserExist?.firstName} />
                      </Col>
                    </Row>

                    <div className="airport-transfer-wrapper">
                      <div className="map-wrapper">
                        <MapSection
                          additionalDirectionData={additionalDirectionData}
                          setAdditionalDirectionData={setAdditionalDirectionData}
                          pickupPlaceId={locationDetails?.from ?? null}
                          dropPlaceId={locationDetails?.to ?? null}
                        />
                      </div>

                      <div className="stepper-form-container">
                        <div className={``}>
                          <ProgressStepper
                            stepperNames={[`Pickup & Drop Location`, `Pickup Date & Time`, `Passenger & Flight Details`, `Review Booking`]}
                            value={currentActiveForm}
                          />
                        </div>
                        {(currentActiveForm === 1 || currentActiveForm === 2) && (
                          <LocationDetailsForm
                            configId={bookingsDetails?.benefitConfigId}
                            randomUUID={randomUUID}
                            selectedUser={isUserExist}
                            currentActiveForm={currentActiveForm}
                            setCurrentActiveForm={setCurrentActiveForm}
                            locationDetails={locationDetails}
                            setLocationDetails={setLocationDetails}
                            selectedDate={selectedDate}
                            setSelectedDate={setSelectedDate}
                            selectedTime={selectedTime}
                            setSelectedTime={setSelectedTime}
                            selectedConfig={selectedConfig}
                            allDates={allDates}
                            allTimes={allTimes}
                          />
                        )}
                        {currentActiveForm === 3 && (
                          <PassengerDetailsForm
                            selectedConfig={selectedConfig}
                            setCurrentActiveForm={setCurrentActiveForm}
                            flightNumber={flightNumber}
                            setFlightNumber={setFlightNumber}
                            passengerDetails={passengerDetails}
                            setPassengerDetails={setPassengerDetails}
                          />
                        )}
                        {currentActiveForm === 4 && (
                          <BookingDetailsForm
                            selectedUser={isUserExist}
                            flightNumber={flightNumber}
                            locationDetails={locationDetails}
                            passengerDetails={passengerDetails}
                            bookingsDetails={bookingsDetails}
                            setCurrentActiveForm={setCurrentActiveForm}
                            additionalDirectionData={additionalDirectionData}
                            selectedDate={selectedDate}
                            selectedTime={selectedTime}
                            setIsShowAddressModal={setIsShowAddressModal}
                            isAddresSaved={isAddresSaved}
                            benefitItemData={benefitItemData?.results?.[0]}
                          />
                        )}
                      </div>
                    </div>
                  </>
                )}

                {currentScreen === `BOOKING_COMPLETE` && historyData?.results?.length === 1 && (
                  <BookingDetails
                    bookingData={historyData?.results?.[0]}
                    setCurrentScreen={setCurrentScreen}
                    setSelectedConfig={setSelectedConfig}
                    setBookingsDetails={setBookingsDetails}
                    setIsUserExist={setIsUserExist}
                  />
                )}
              </div>
            </CardBody>
          </Card>
        )}
      </div>
    </div>
  );
}

function generateRandomString(length = 10) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }
  return result;
}

function generateDailyTimeSlots() {
  const times = [];

  for (let hour = 0; hour < 24; hour++) {
    for (let min = 0; min < 60; min += 15) {
      const time = new Date();
      time.setHours(hour, min, 0, 0);
      times.push(format(time, 'hh:mm a'));
    }
  }

  return times;
}
